import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useModal } from '../hooks/use-modal'
import { Popup } from './popup'

const Outer = styled.div`
  display: grid;
  grid-template-columns: 10rem 1fr;
  border-left: 1px solid #C1C1C1;
  border-right: 1px solid #C1C1C1;
  @media (max-width: 40rem){
    grid-template-columns: 9rem 1fr;
  }
`

const Row = styled.div`
  display: grid;
  grid-template-columns: subgrid;
  grid-column: span 2;
  border-top: 1px solid #C1C1C1;
  &:last-child {
    border-bottom: 1px solid #C1C1C1;
  }
`

const Cell = styled.div`
  padding: 0.9375rem 1.75rem;
  font-size: 0.9375rem;
  line-height: 1.6;
  @media (max-width: 40rem){
    font-size: 0.8125rem;
    line-height: 1.3846153846153846;
  }
  a {
    color: var(--blue);
    text-decoration: underline;
  }
  a[href^="https://maps.app.goo.gl/"],
  a[href^="https://www.google.com/maps/"] {
    &::after {
      content: '';
      display: inline-block;
      aspect-ratio: 18.8917 / 11.6;
      height: 1em;
      width: auto;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.792 12.5"><path fill="none" stroke="%230065ac" stroke-width=".9" d="M3.575 3.575V1.5c0-.58.47-1.05 1.05-1.05h13.667c.58 0 1.05.47 1.05 1.05v6.375c0 .58-.47 1.05-1.05 1.05h-2.075"/><path fill="%23fff" stroke="%230065ac" stroke-width=".9" d="M1.5 3.575h13.667c.58 0 1.05.47 1.05 1.05V11c0 .58-.47 1.05-1.05 1.05H1.5C.92 12.05.45 11.58.45 11V4.625c0-.58.47-1.05 1.05-1.05z"/></svg>');
      background-repeat: no-repeat;
      background-position: center center;
      vertical-align: baseline;
      transform: translateY(0.1em);
      margin-left: 0.25rem;
    }
  }
`

const Head = styled(Cell)`
font-weight: 700;
background-color: #F4F4F6;
`

type TableProps = {
  data: {
    label: string,
    value: string
  }[]
}
export const Table: FunctionComponent<TableProps> = ({data}) => {
  const {open} = useModal()
  return <Outer>
    {
      data.map((row, i) => {
        return <Row key={i}>
          <Head dangerouslySetInnerHTML={{__html: row.label}} />
          <Cell dangerouslySetInnerHTML={{__html: row.value}} onClick={e => {
            const target = e.target
            if(target instanceof HTMLAnchorElement && target.origin !== location.origin && !/^(https:\/\/maps.app.goo.gl\/|https:\/\/www.google.com\/maps\/)/.test(target.href)){
              e.preventDefault()
              open(({resolve}) => <Popup onClose={resolve} data={{
                siteName: target.href,
                url: target.href
              }} />)
            }
          }}/>
        </Row>
      })
    }
  </Outer>
}